import { Skeleton } from "@/components/ui/skeleton";

export const ProjectDetailSkeleton = () => {
  return (
    <div className="container mx-auto py-10 px-4">
      {/* Back Button Skeleton */}
      <Skeleton className="h-6 w-32 mb-6" />

      <div className="grid lg:grid-cols-3 gap-10">
        {/* Left Side: Main Content */}
        <div className="lg:col-span-2 space-y-6">
          <div className="flex gap-2">
            <Skeleton className="h-6 w-24" />
            <Skeleton className="h-6 w-24" />
          </div>
          <Skeleton className="h-12 w-full" />
          <Skeleton className="h-[400px] w-full rounded-xl" />
          <Skeleton className="h-32 w-full" />
        </div>

        {/* Right Side: Sidebar */}
        <div className="space-y-6">
          <Skeleton className="h-[200px] w-full" />
          <Skeleton className="h-[200px] w-full" />
          <Skeleton className="h-[300px] w-full" />
        </div>
      </div>
    </div>
  );
};